import type { Filter } from '@cubejs-client/core';
import { create } from 'zustand';

// API-layer seam for pre-constraining the filter panel's dropdown options to a
// context set by a page. Domain-neutral (opaque Filter[]) so `useGetFilterOptions`
// never depends on a page module. A store, not a variable, so option queries
// recompute when the scope changes.
interface OptionScopeState {
  filters: Filter[];
  setScopeFilters: (filters: Filter[]) => void;
  clearScopeFilters: () => void;
}

// Stable empty reference so the cleared state keeps identity across renders,
// letting `useOptionScopeFilters` consumers skip re-renders when nothing changed.
const EMPTY_SCOPE_FILTERS: Filter[] = [];

export const useOptionScopeStore = create<OptionScopeState>()(set => ({
  filters: EMPTY_SCOPE_FILTERS,
  setScopeFilters: filters => set({ filters }),
  clearScopeFilters: () => set({ filters: EMPTY_SCOPE_FILTERS }),
}));

export const useOptionScopeFilters = (): Filter[] => useOptionScopeStore(state => state.filters);
